const PATH = "/api/v1/supply";

const ENDPOINTS = {
  SUPPLY_COUNTRIES: "/countries/",
  SUPPLY_STATES: "/states/",
  SUPPLY_DISTRICTS: "/districts/",
  SUPPLY_SEARCH_LOCATION: "/search/location/",
  SUPPLY_SEED: "/seed/",
  SUPPLY_LEADS: "/leads/",
  SUPPLY_LEAD: "/lead/",
  SUPPLY_LEADS_LOCATION: "/leads/location/",
  SUPPLY_LEADS_ANSWER: "/leads/answer/",
  SUPPLY_LEADS_QUESTIONS: "/leads/questions/",
  SUPPLY_LEADS_HISTORY: "/leads/history/",
  SUPPLY_LEADS_COUNT: "/leads/count/",
};

export type SupplyEndpoints = keyof typeof ENDPOINTS;
export const SupplyCollection = { PATH, ENDPOINTS };
